import * as React from "react";
const SvgOrg2 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="org-2_svg__svg-icon"
    style={{
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden",
    }}
    viewBox="0 0 1024 1024"
    data-icon="1"
    {...props}
  >
    <path d="M695.7 176.3 892.1 303v22.6l-174.6-108v42.9l174.5 101v22.7l-174.5-96.5v42.8L892 419.9v22.7l-174.4-84.9v42.9L892 478.3V501l-174.4-73.2v42.9L892 536.8v22.7l-174.4-61.6v42.9l174.3 54.5V618l-174.3-50v42.9l174.3 42.9v22.7l-174.3-38.4v42.8L891.8 712v22.7l-174.3-26.8v42.8l174.2 19.7v22.7l-174.2-15.2v42.8l174.2 8.1v18.7H361.8v-14.7l319.9-12.7V777l-319.9 24.1v-20.2l319.9-31.3v-43.3L361.9 749v-20.2l319.8-49.9v-43.3l-319.8 61.2v-20.3l319.8-68.4v-43.2l-319.8 79.8v-20.2l319.8-87v-43.2L362 592.6v-20.2l319.7-105.5v-43.2L362 540.5v-20.3l319.7-124.1v-43.2L362 488.3v-20.2l319.7-142.6v-43.2L362 436.3v-20.2l319.6-161.2v-43.2L362.1 384v-20.2l333.6-187.5zM183.9 847.7V474.2l40-20.8v394.3h125.9l1.1-431.4-101.4-47.7-106.9 66.6v412.5z" />
    <path d="M64.4 815.3h895.1v32.3H64.4z" />
  </svg>
);
export default SvgOrg2;
